import React, { useRef } from "react";
import { Form } from "react-bootstrap";

function UploadDocComponent({
  onUpload = () => {},
  label = "BROWSE",
  extensions = "image/*",
  filesName = "",
  comment = "",
  feedback = ""
}) {
  const fileRef = useRef(null);

  const handleChange = e => {
    onUpload(e);
    if (fileRef.current) {
      fileRef.current.value = "";
    }
  };
  return (
    <>
      <Form className="upload-image-input">
        <Form.File
          isValid
          ref={fileRef}
          custom
          label={""}
          onChange={handleChange}
          accept={extensions}
          data-browse={label}
          feedback={feedback}
        />
      </Form>
    </>
  );
}

export { UploadDocComponent };
